import { View } from "@/components/ui";
import { GetTheAppNow } from "../get-the-app-now";
import { NavbarListItem } from "../navbar-list-item";
import { Bell, CaretDown, Question, SignOut } from "@/components/shared/icons";
import { UserAvatar } from "../user-avatar";
import { useState } from "react";
import { cn } from "@/lib/utils";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu/index.web";
import { useAuthState } from "@/store/auth";
import { Link } from "@/components/shared/link";
import { Divider } from "@/components/shared/divider";
import { useRoute } from "@/components/shared/router";
import { AuthModals } from "@/types/users";
import { links } from "@/constants";
import { handleOpenLink } from "@/lib/platform";
import { useAuth } from "../../auth-provider";
import { PosthogAnalytics } from "@/lib/monitoring/posthog";

export function UserDropdown() {
  const [open, setOpen] = useState(false);
  const { push } = useRoute();
  const {
    data: { userInfo, unreadNotificationCount },
    showModal,
  } = useAuthState();
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return (
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger style={{ outline: "none" }}>
          <View
            className={cn(
              "ease flex cursor-pointer items-center gap-1 rounded-full bg-brand-over-static pr-1 text-white transition",
            )}
          >
            <UserAvatar
              badged={
                !!userInfo.billingAccount.totalOverdueInvoice ||
                !!unreadNotificationCount
              }
            />
            <View
              className={cn("transition duration-300 ease-in-out", {
                "rotate-180": open,
              })}
            >
              <CaretDown />
            </View>
          </View>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="mr-8 mt-2 rounded-lg border-brand-static-border bg-brand-static p-4 text-brand-on-static">
          <View className="grid w-[250px] gap-2">
            <Link href="/profile">
              <NavbarListItem
                title="Account"
                icon={<UserAvatar />}
                size="small"
                onClick={() => {
                  setOpen(false);
                }}
              />
            </Link>
            <Divider className="opacity-25" />
            <Link href="/notifications">
              <NavbarListItem
                icon={<Bell size={22} />}
                title="Notification"
                badge={
                  unreadNotificationCount > 0
                    ? String(unreadNotificationCount)
                    : undefined
                }
              />
            </Link>
            <Divider className="opacity-25" />
            <View>
              <NavbarListItem
                icon={<Question size={22} />}
                title="Help"
                onClick={() => {
                  setOpen(false);
                  handleOpenLink(links.helpCenter);
                }}
              />
              <NavbarListItem
                icon={<SignOut size={22} />}
                title="Logout"
                onClick={() => {
                  setOpen(false);
                  showModal(AuthModals.LOGOUT);
                }}
              />
            </View>
            <Divider className="opacity-25" />
            <GetTheAppNow className="py-3" />
          </View>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger style={{ outline: "none" }}>
        <View
          className={cn(
            "ease flex cursor-pointer items-center gap-1 rounded-full bg-brand-over-static pr-1.5 text-white transition",
          )}
        >
          <UserAvatar />
          <View
            className={cn("transition duration-300 ease-in-out", {
              "rotate-180": open,
            })}
          >
            <CaretDown />
          </View>
        </View>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="mr-8 mt-2 rounded-lg border-brand-static-border bg-brand-static p-4 text-brand-on-static">
        <View className="grid w-[250px] gap-2">
          <NavbarListItem
            title="Sign In"
            onClick={() => {
              setOpen(false);
              // showModal(AuthModals.LOGIN);
              push({ pageKey: "login" });
            }}
          />
          <NavbarListItem
            title="Sign Up"
            onClick={() => {
              setOpen(false);
              PosthogAnalytics.track("user_sign_up");
              push({ pageKey: "signup" });
            }}
          />
          <Divider className="opacity-25" />
          <NavbarListItem
            icon={<Question size={22} />}
            title="Help"
            onClick={() => {
              setOpen(false);
              handleOpenLink(links.helpCenter);
            }}
          />
          <Divider className="opacity-25" />
          <GetTheAppNow size="small" className="pb-3 pt-10" />
        </View>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
